class ReviewSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.swiper) {
      this.initSwiper();
    }
  }

  initSwiper() {
    const buttonNext = this.querySelector(".swiper-button-next");
    const buttonPrev = this.querySelector(".swiper-button-prev");

    const sliderEl = this.querySelector('.swiper');

    // 👉 Read data attributes from <review-slider>
    const enableAutoplay = this.dataset.enableAutoplay === "true";
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 3;
    const autoplaySpeedMilliseconds = autoplaySpeed * 1000;
    const loop = this.dataset.sliderLoop === "true";

    this.swiper = new Swiper(sliderEl, {
      loop: loop,
      spaceBetween: 0,
      slidesPerView: 1,

      // ✅ Autoplay conditionally enabled
      autoplay: enableAutoplay
      ? {
          delay: autoplaySpeedMilliseconds,
          disableOnInteraction: false,
        }
      : false,

      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },

      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },

      breakpoints: {
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
    });
  }
}

customElements.define('review-slider', ReviewSlider);